import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("BnplApplicationSignatureStore");

const urls = {
  signatures: (loanApplicationId) =>
    `/bnpl/application-signatures/${loanApplicationId}`,
  signature: (id) => `/bnpl/application-signature/${id}`,
  signatureWithdraw: (id) => `/bnpl/application-signature/withdraw/${id}`,
};

const initState = () => {
  return {
    signatures: {},
    signature: {},
  };
};

const actions = {
  fetchAll: async ({ commit }, loanApplicationId) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.signatures(loanApplicationId));
      commit("saveAll", {
        loanApplicationId,
        data,
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetch: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.signature(id));
      commit("save", {
        id,
        data,
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  create: async ({}, { id, data }) => {
    try {
      const axios = await network.connection();
      await axios.post(urls.signature(id), data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  withdraw: async ({}, id) => {
    try {
      const axios = await network.connection();
      await axios.patch(urls.signatureWithdraw(id));
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveAll: (state, { loanApplicationId, data }) => {
    Vue.set(state.signatures, loanApplicationId, data);
  },
  save: (state, { id, data }) => {
    Vue.set(state.signature, id, data);
  },
};

const getters = {
  getAll: (state) => (loanApplicationId) => {
    return state.signatures[loanApplicationId];
  },
  get: (state) => (id) => {
    return state.signature[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
